import type { DiffereNavigationRequest, LibraryNavigationRequest } from '../../types/app';
import type { ChatDeepLink } from '../../utils/chatDeepLinks';
import {
  getDiffereDeepLinkPresentation,
  getLibraryDeepLinkPresentation,
} from '../../utils/chatDeepLinks';

interface ChatDeepLinkCardProps {
  link: ChatDeepLink;
  onOpenLibrary: (request: LibraryNavigationRequest) => void;
  onOpenDiffere: (request: DiffereNavigationRequest) => void;
}

export default function ChatDeepLinkCard({
  link,
  onOpenLibrary,
  onOpenDiffere,
}: ChatDeepLinkCardProps) {
  const presentation = link.kind === 'library'
    ? getLibraryDeepLinkPresentation(link.request)
    : getDiffereDeepLinkPresentation(link.request);

  const icon = link.kind === 'library' ? '📚' : '🏆';
  const handleOpen = () => {
    if (link.kind === 'library') onOpenLibrary(link.request);
    else onOpenDiffere(link.request);
  };

  return (
    <div className="game-invite-card chat-deep-link-card">
      <div className="game-invite-header">
        <span className="game-invite-icon" aria-hidden="true">{icon}</span>
        <div className="game-invite-title-wrap">
          <span className="game-invite-title">{presentation.title}</span>
          <span className="game-invite-subtitle">{presentation.subtitle}</span>
        </div>
      </div>

      <p className="chat-deep-link-footer">{presentation.footer}</p>

      <div className="game-invite-actions">
        <button
          type="button"
          className="game-invite-btn access"
          onClick={handleOpen}
        >
          {presentation.actionLabel}
        </button>
      </div>
    </div>
  );
}
